import React from "react";
import { Loader2 } from "lucide-react";

// Every report page under this shell had the same gap: real content only
// ever appears once loading is false, and the empty-state message is
// (correctly) also gated on !loading -- so there was nothing at all in
// between "page just opened" and "data arrived," reading as a stuck/broken
// blank page rather than a page that's working on it. Reuses the app's own
// lv-spin keyframe (already defined in index.css, already used for every
// other in-app spinner) instead of introducing a second animation.
export default function LoadingState({ label = "Loading…" }) {
  return (
    <div style={styles.wrap}>
      <Loader2 size={20} color="var(--brand)" style={{ animation: "lv-spin 0.8s linear infinite" }} />
      <div style={styles.label}>{label}</div>
    </div>
  );
}

const styles = {
  wrap: {
    display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
    gap: 10, padding: "48px 20px", color: "var(--muted)",
  },
  label: { fontSize: 13, fontWeight: 600 },
};
